var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    width: 152.3,
    height: 67,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.3 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.8,23.1h6.6v2.6c1.3-1.3,2.3-2.2,3.2-2.7,1-.5,2.1-.7,3.6-.7,3.2,0,5.7,1.4,7.6,4.2,2.1-2.8,4.9-4.2,8.4-4.2,6.4,0,9.6,3.9,9.6,11.6v12.3h-6.6v-10.5c0-2.7-.3-4.6-1-5.8-.7-1.1-1.8-1.7-3.4-1.7s-3.1.7-4,2c-.8,1.4-1.2,3.5-1.2,6.6v9.4h-6.6v-10.4c0-5.1-1.5-7.6-4.4-7.6s-3.2.7-4,2.1c-.8,1.4-1.3,3.6-1.3,6.5v9.4h-6.6v-23.1h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.4,46.3l-12.8-23.1h7.6l8.7,16.3,8.1-16.3h7.4l-22.6,43.9h-7.5l11.1-20.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85,23.2c0-6.1,2.2-11.3,6.7-15.7,4.4-4.4,9.8-6.6,16-6.6s11.4,2.2,15.9,6.6c4.4,4.4,6.6,9.7,6.6,15.9s-2.2,11.5-6.7,15.8c-4.5,4.4-9.9,6.5-16.2,6.5s-10.6-1.9-15-5.8c-4.9-4.3-7.3-9.9-7.3-16.8h0ZM91.6,23.3c0,4.8,1.6,8.7,4.8,11.8,3.2,3.1,6.9,4.6,11.1,4.6s8.4-1.6,11.5-4.7c3.1-3.2,4.7-7,4.7-11.6s-1.5-8.5-4.6-11.6c-3.1-3.1-6.9-4.7-11.4-4.7s-8.3,1.6-11.4,4.7c-3.1,3.1-4.7,6.9-4.7,11.5h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.3,42.7h8.2v3.1h-14.8l7.6-9.2c.7-.9,1.4-1.7,1.9-2.4s.9-1.2,1.2-1.7c.5-.9.8-1.7.8-2.4,0-1-.4-1.9-1.1-2.6s-1.6-1-2.7-1c-2.2,0-3.5,1.3-3.8,3.9h-3.3c.5-4.6,2.9-6.9,7-6.9s3.7.6,5,1.9c1.4,1.3,2,2.8,2,4.7s-.3,2.4-1,3.5c-.3.6-.8,1.3-1.4,2.1-.6.8-1.4,1.8-2.4,2.9l-3.4,4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.198906a6f742fd6af8110130be8d76dd.svg";
export { ForwardRef as ReactComponent };